import { Navigate } from 'react-router-dom';

import { useCurrentUser } from '../lib/useCurrentUser';

/**
 * 首页路由：根据当前用户角色跳到默认入口。
 *   平台管理员 → /admin/dashboard（运营总览）
 *   销售员 / 销售主管 → /sales/leads（销售工作台）
 */
export function HomeRedirect() {
  const me = useCurrentUser();
  if (me.isLoading) {
    return (
      <div className="text-slate-500 text-sm">加载中…</div>
    );
  }
  if (me.data?.role === 'admin') {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return <Navigate to="/sales/leads" replace />;
}
